import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import {deleteSegment} from '@/api/fetchers/segments';
import {SEGMENTS_QUERY_KEY} from '@/hooks/queries/use-segments-query';

export type DeleteSegmentVariables = {
  id: string;
  merchantId: string;
};

export default function useDeleteSegmentMutation() {
  return useMutation<void, Error, DeleteSegmentVariables>({
    mutationKey: [SEGMENTS_QUERY_KEY, 'delete'],
    mutationFn: ({id, merchantId}) => deleteSegment(id, merchantId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [SEGMENTS_QUERY_KEY]});
    },
  });
}
